'use strict';

export const fr_CA = {
    name: 'fr_CA',
    closeText: 'Fermer',
    prevText: 'Pr&eacute;c',
    nextText: 'Suiv',
    currentText: 'Aujourd\'hui',
    monthNames: ['Janvier ', 'F&eacute;vrier', 'Mars', 'Avril', 'Mai', 'Juin',
        'Juillet', 'Ao&ucirc;t', 'Septembre', 'Octobre', 'Novembre', 'D&eacute;cembre'],
    monthNamesShort: ['Jan', 'F&eacute;v', 'Mar', 'Avr', 'Mai', 'Jui',
        'Jui', 'Ao&ucirc;', 'Sep', 'Oct', 'Nov', 'D&eacute;c'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    weekHeader: 'Wk',
    dateFormat: 'dd/mm/yy',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
};
